import { useEffect } from "react";
import usePrevProps from "./usePrevProps";
import { toastr } from "react-redux-toastr";

export const useLoading = (
  isLoading: boolean | undefined,
  error: string | undefined | Array<any> ,
  onSuccess?: () => void,
  onError?: () => void
) => {
  const prevProps = usePrevProps({ isLoading });

  useEffect(() => {
    if (prevProps?.isLoading && !isLoading) {
      if (error) {
        if(error !== "MULTIPLE_ERRORS") {
          toastr.error("Failed", Array.isArray(error) ? error.join(", ") : error);
        }
        onError && onError();
      } else {
        onSuccess && onSuccess();
      }
    }
  }, [isLoading, prevProps?.isLoading]);
};
